export const setDarkThemeAction = (isDarkTheme) => ({
    type: 'SET_DARK_THEME',
    payload: isDarkTheme,
  });
  